import React from 'react';
import { Link } from 'react-router-dom';

function NotFoundPage() {
  return (
    <div style={{
      padding: '120px 20px 80px',
      textAlign: 'center',
      fontFamily: 'Montserrat, sans-serif',
      minHeight: '60vh',
    }}>
      <h1 style={{ color: '#2257B4', fontSize: '5em', margin: 0 }}>404</h1>
      <h2 style={{ color: '#333', marginTop: 0 }}>Página no encontrada</h2>
      <p style={{ color: '#666', marginBottom: 32 }}>
        La página que buscás no existe o fue movida.
      </p>
      <Link
        to="/"
        style={{
          background: '#2257B4',
          color: '#fff',
          padding: '12px 28px',
          borderRadius: 6,
          textDecoration: 'none',
          fontWeight: 600,
        }}
      >
        Volver al inicio
      </Link>
    </div>
  );
}

export default NotFoundPage;
